import { useStaleCheckoutFeatureFlag } from "@/core/splitio";
import { useCallback, useEffect, useRef, useState } from "react";

export const PAYMENT_MODAL_TIMEOUT_MS = 20 * 60 * 1000;

export const usePaymentTimer = (isModalOpen: boolean) => {
  const [isExpired, setIsExpired] = useState(false);
  const staleCheckoutFeatureFlag = useStaleCheckoutFeatureFlag();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!staleCheckoutFeatureFlag) {
      return;
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (isModalOpen) {
      setIsExpired(false);
      timeoutRef.current = setTimeout(() => {
        setIsExpired(true);
      }, PAYMENT_MODAL_TIMEOUT_MS);
    } else {
      setIsExpired(false);
      timeoutRef.current = null;
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [isModalOpen, staleCheckoutFeatureFlag]);

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsExpired(false);
  }, []);

  return {
    isExpired,
    resetTimer,
  };
};
